import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { COLORS } from '../../utils';
const crossIcon = ({ className, strokeWidth, hexFill: fill, viewBox, onClick, height = "10px", width = "10px", onPointerEnter, onPointerLeave }) => {
    const hexFill = fill || COLORS.midnight;
    return (_jsx("svg", { onClick: onClick, className: className || '', width: width, height: height, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave, viewBox: viewBox ? viewBox.join(' ') : '0 0 10 10', version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", children: _jsx("path", { d: "M9 9L1 1M1 9L9 1L1 9Z", stroke: hexFill, strokeWidth: strokeWidth }) }));
};
export default crossIcon;
